import { AccountChildCircleIcon } from './AccountChildCircleIcon';

/**
 * author: Google
 * id AF386BC9-683F-42B4-97DA-C256CF82C79F
 * name account-child-circle
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-child-circle.svg
 * tags
 * - Account / User 
 */
export const UserChildCircleIcon = AccountChildCircleIcon;
export default UserChildCircleIcon